import { t } from 'i18next';

import { TFormData } from '#/client';
import Form from '#/components/Form/Form';
import { createPlanFormConfig } from '#/components/Form/formUtils';
import { PlanPickerSubText } from '#/plugins/paywall/components';
import { getSelectedPlan, transformPlans } from '#/plugins/paywall/utils';

import { PlanSelectionProps } from '../../types';

const KEY_ROOT = 'planSelection';

// TODO: handle this better
export const getDescription = () => {
  const webOnlyKey = 'web.iap.description';
  let result = t(webOnlyKey);

  // check if we have a web only description
  if (result && result !== webOnlyKey) {
    return result;
  }

  const allPlatformsKey = 'iap.description';
  result = t(allPlatformsKey);

  // fall back to the default description. if it's also missing, don't display anything.
  return result === allPlatformsKey ? null : result;
};

const PlanSelection = ({
  plans,
  selectedPlan,
  nextStep,
  onPlanChange,
}: PlanSelectionProps) => {
  const description = getDescription();

  const handleNextStep = (data: TFormData) => {
    const { plan, errorMessage } = getSelectedPlan(data, plans);

    if (plan) {
      onPlanChange(plan);
      nextStep();
    } else if (errorMessage) {
      console.warn(errorMessage);
    }
  };

  const inputGroups = createPlanFormConfig(
    KEY_ROOT,
    transformPlans(KEY_ROOT, plans),
    {
      hasSubmitButton: false,
      main: { textKeyPath: 'button.continue', onClick: handleNextStep },
    },
    selectedPlan?.id
  );

  return (
    <>
      <Form inputGroups={inputGroups} />
      {description && (
        <PlanPickerSubText $isCentered>{description}</PlanPickerSubText>
      )}
    </>
  );
};

PlanSelection.displayName = 'PlanSelection';

export default PlanSelection;
